import { render, staticRenderFns } from "./album-list.vue?vue&type=template&id=c3d0e658&scoped=true"
import script from "./album-list.vue?vue&type=script&lang=js"
export * from "./album-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d0e658",
  null
  
)

export default component.exports